import styled from '@emotion/styled'
import { SvgIcon, SvgIconProps } from '@mui/material'

const StyledPath = styled.path`
  fill: ${(p) => p.theme.colors.duskBlue}; ;
`

const ExpandIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 45.12 21.15">
    <StyledPath
      d="M57.653 33.723a2.007 2.007 0 0 0-2.829-.257L35.56 49.527 16.295 33.466a2.009 2.009 0 0 0-2.573 3.086l20.551 17.132a2.008 2.008 0 0 0 2.573 0L57.4 36.552a2.008 2.008 0 0 0 .253-2.829z"
      transform="translate(-13 -33)"
    />
  </SvgIcon>
)

export default ExpandIcon
